import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInsightCalm = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 329 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Group 15893",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_0_17",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 329,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle 1243",
				width: 329,
				height: 24,
				fill: "var(--fill-0, #D9D9D9)"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_0_17)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector 87 (Stroke)",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M0.862793 12C0.862793 11.1716 1.53437 10.5 2.36279 10.5H14.5606C15.389 10.5 16.0606 11.1716 16.0606 12C16.0606 12.8284 15.389 13.5 14.5606 13.5H2.36279C1.53437 13.5 0.862793 12.8284 0.862793 12ZM29.3243 12C29.3243 11.1716 29.9959 10.5 30.8243 10.5H43.0221C43.8506 10.5 44.5221 11.1716 44.5221 12C44.5221 12.8284 43.8506 13.5 43.0221 13.5H30.8243C29.9959 13.5 29.3243 12.8284 29.3243 12ZM57.7859 12C57.7859 11.1716 58.4574 10.5 59.2859 10.5H71.4837C72.3121 10.5 72.9837 11.1716 72.9837 12C72.9837 12.8284 72.3121 13.5 71.4837 13.5H59.2859C58.4574 13.5 57.7859 12.8284 57.7859 12ZM86.2474 12C86.2474 11.1716 86.919 10.5 87.7474 10.5H99.9452C100.774 10.5 101.445 11.1716 101.445 12C101.445 12.8284 100.774 13.5 99.9452 13.5H87.7474C86.919 13.5 86.2474 12.8284 86.2474 12ZM114.709 12C114.709 11.1716 115.381 10.5 116.209 10.5H128.407C129.235 10.5 129.907 11.1716 129.907 12C129.907 12.8284 129.235 13.5 128.407 13.5H116.209C115.381 13.5 114.709 12.8284 114.709 12ZM143.17 12C143.17 11.1716 143.842 10.5 144.67 10.5H156.868C157.697 10.5 158.368 11.1716 158.368 12C158.368 12.8284 157.697 13.5 156.868 13.5H144.67C143.842 13.5 143.17 12.8284 143.17 12ZM171.632 12C171.632 11.1716 172.304 10.5 173.132 10.5H185.33C186.158 10.5 186.83 11.1716 186.83 12C186.83 12.8284 186.158 13.5 185.33 13.5H173.132C172.304 13.5 171.632 12.8284 171.632 12ZM200.094 12C200.094 11.1716 200.765 10.5 201.594 10.5H213.791C214.62 10.5 215.291 11.1716 215.291 12C215.291 12.8284 214.62 13.5 213.791 13.5H201.594C200.765 13.5 200.094 12.8284 200.094 12ZM228.555 12C228.555 11.1716 229.227 10.5 230.055 10.5H242.253C243.081 10.5 243.753 11.1716 243.753 12C243.753 12.8284 243.081 13.5 242.253 13.5H230.055C229.227 13.5 228.555 12.8284 228.555 12ZM257.017 12C257.017 11.1716 257.688 10.5 258.517 10.5H270.714C271.543 10.5 272.214 11.1716 272.214 12C272.214 12.8284 271.543 13.5 270.714 13.5H258.517C257.688 13.5 257.017 12.8284 257.017 12ZM285.478 12C285.478 11.1716 286.15 10.5 286.978 10.5H299.176C300.004 10.5 300.676 11.1716 300.676 12C300.676 12.8284 300.004 13.5 299.176 13.5H286.978C286.15 13.5 285.478 12.8284 285.478 12ZM313.94 12C313.94 11.1716 314.611 10.5 315.44 10.5H327.638C328.466 10.5 329.138 11.1716 329.138 12C329.138 12.8284 328.466 13.5 327.638 13.5H315.44C314.611 13.5 313.94 12.8284 313.94 12Z",
				fill: "var(--fill-0, #DFCBF5)"
			})
		})]
	})
});
export default SvgInsightCalm;
